module.exports = __webpack_public_path__ + "static/img/icon-long-outstanding1.9394ab0f.svg";